<template>
  <dropdown
    class="settings"
    :visible="visible"
    animation="ani-fade"
    :position="['right', 'bottom', 'right', 'top']"
    @clickout="visible=false">
    <button class="link"  @click="visible=true">
      <div class="settings__icon">
        {{ $t('explorer.optionsDropdown') }}
      </div>
      <div class="trigger">
        <font-awesome-icon :icon="icon.angleDown" />
      </div>
    </button>
    <div slot="dropdown" class="dialog">
      <ul class="dialog__list">
        <li>
          <span
            href="#"
            class="dialog__item clickable"
            @click="gridStateChange">
            <checkbox
              check-size="xs"
              class="option-checkbox"
              :checked="gridVisibleChecked"/>
            <span class="dialog__item-text">{{ $t('explorer.evolutionOptions.gridVisibleChecked') }}</span>
          </span>
        </li>
        <li v-if="enabledRange">
          <span
            href="#"
            class="dialog__item clickable"
            @click="fixedAxes">
            <font-awesome-icon class="dialog__category-icon" :icon="icon.arrows" />
            <span class="dialog__item-text">{{ $t('explorer.correlationOptions.fixedAxes') }}</span>
          </span>
        </li>
        <li>
          <span
            href="#"
            class="dialog__item clickable"
            @click="toEvolution">
            <font-awesome-icon class="dialog__category-icon" :icon="icon.chartLine" />
            <span class="dialog__item-text">{{ $t('explorer.correlationOptions.toEvolution') }}</span>
          </span>
        </li>
        <li v-if="hasIntensity">
          <span
            href="#"
            class="dialog__item clickable"
            @click="switchMeter">
            <font-awesome-icon class="dialog__category-icon" :icon="icon.color" />
            <span class="dialog__item-text">
              {{ this.meter === 'divergent' ? $t('explorer.correlationOptions.sequential') : $t('explorer.correlationOptions.divergent') }}
            </span>
          </span>
        </li>
        <li>
          <span
            href="#"
            class="dialog__item clickable"
            @click="exchangeAxes">
            <font-awesome-icon class="dialog__category-icon" :icon="icon.exchange" />
            <span class="dialog__item-text">
              {{ $t('explorer.correlationOptions.exchangeAxes') }}
            </span>
          </span>
        </li>
      </ul>
    </div>
  </dropdown>
</template>

<script>
import dropdown from 'vue-my-dropdown';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import checkbox from '@/components/shared/forms/Checkbox';
import { faAngleDown } from '@fortawesome/fontawesome-free-solid';
import { faFillDrip, faArrowsAltV, faChartLine, faExchangeAlt } from '@fortawesome/pro-light-svg-icons';

export default {
  name: 'OptionsCorrelation',
  components: {
    dropdown,
    FontAwesomeIcon,
    checkbox
  },
  props: {
    hasIntensity: {
      type: Boolean,
      default: false
    },
    enabledRange: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      icon: {
        angleDown: faAngleDown,
        arrows: faArrowsAltV,
        chartLine: faChartLine,
        color: faFillDrip,
        exchange: faExchangeAlt
      },
      visible: false,
      gridVisibleChecked: false,
      meter: 'divergent'
    };
  },
  methods: {
    setGridState (gridSelected) {
      this.gridVisibleChecked = gridSelected;
    },
    setMeter (meter) {
      this.meter = meter;
    },
    fixedAxes () {
      this.visible = false;
      this.$emit('onFixedAxes');
    },
    toEvolution () {
      this.visible = false;
      this.$emit('onEvolution');
    },
    gridStateChange () {
      this.visible = false;
      this.gridVisibleChecked = !this.gridVisibleChecked;
      this.$emit('onGridStateChange', this.gridVisibleChecked);
    },
    switchMeter () {
      this.visible = false;
      if (this.meter === 'divergent') {
        this.meter = 'sequential';
      } else {
        this.meter = 'divergent';
      }
      this.$emit('onSwitchMeter', this.meter);
    },
    exchangeAxes () {
      this.visible = false;
      this.$emit('onExchangeAxes');
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../stylesheets/variables.scss";

.settings {
  margin-left: auto;
  .link {
    display: flex;
    align-items: center;
    background-color: transparent;
    border: 0;
    color: inherit;
    &:hover,
    &:focus {
      opacity: 0.75;
      cursor: pointer;
      outline: 0;
    }
  }
  &__icon {
    margin-right: $sp;
  }
  .trigger svg {
    transform: scale(0.875);
    transform-origin: bottom;
  }

  .clickable {
    cursor: pointer;
  }

  .option-checkbox {
    margin-bottom: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/explorer/correlation/OptionsCorrelation.vue